import { apiClient } from './auth';

export const parkingsService = {
  async getParkings({ page = 1, pageSize = 10 }: { page?: number; pageSize?: number } = {}) {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
    });
    return apiClient.get(`/admin/parkings?${params}`);
  },

  async getParking(id: string) {
    return apiClient.get(`/admin/parkings/${id}`);
  },

  async createParking(data: any) {
    return apiClient.post('/admin/parkings', data);
  },

  async updateParking(id: string, data: any) {
    return apiClient.put(`/admin/parkings/${id}`, data);
  },

  async deleteParking(id: string) {
    return apiClient.delete(`/admin/parkings/${id}`);
  },
};